import React, { useEffect } from 'react';
import Hero from '../components/home/Hero';
import Courses from '../components/home/Courses';
import Benefits from '../components/home/Benefits';
import Cta from '../components/home/Cta';
import ReviewSection from '../components/home/ReviewSection';
import Seo from '../components/common/Seo';

const HomePage = () => {
  useEffect(() => {
    // URL에 #benefits가 있으면 해당 섹션으로 스크롤
    if (window.location.hash === '#benefits') {
      const element = document.getElementById('benefits');
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "auto"
        });
      }
    }
  }, []);

  return (
    <>
      <Seo
        title="ElectroWave Club — 1:1 멘토 매칭 코딩 스터디"
        description="Java · React · TypeScript · AI 코딩까지, 줌(Zoom) 실시간 1:1 멘토링으로 진행하는 실무 중심 코딩 스터디 클럽."
        path="/"
        ogType="website"
      />
      <Hero />
      <Courses />
      <Benefits />
      <ReviewSection />
      <Cta />
    </>
  );
};

export default HomePage;
